import React from 'react';
import { Link } from 'react-router-dom';

import Icon from 'components/DesignSystem/Icon';
import Button from 'components/DesignSystem/Button';
import { ProductCardEntry } from 'helper/Home/productCardList';
import useProductLinks from 'utils/hooks/home/useProductLinks';
import { cssVar } from 'constants/theme';

import './index.scss';

export default function ProductModuleItem({
  product,
  isOpen,
  onToggle,
}: {
  product: ProductCardEntry;
  isOpen: boolean;
  onToggle: () => void;
}) {
  const links = useProductLinks(product.product, product.subproduct);
  const hasLinks = links.length > 0;

  return (
    <div className={`product-module-item${isOpen ? ' open' : ''}`}>
      <button
        type="button"
        className="product-module-header"
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        <span className="product-module-icon">
          <Icon iconType={product.icon || 'folder'} color={cssVar('text-strong')} />
        </span>
        <span className="product-module-texts">
          <span className="product-module-name">{product.name}</span>
          {hasLinks ? (
            <span className="product-module-count">
              {links.length}
              {' '}
              recurso
              {links.length === 1 ? '' : 's'}
            </span>
          ) : product.description && (
            <span className="product-module-count">{product.description}</span>
          )}
        </span>
        <Icon
          iconType={isOpen ? 'down_arrow' : 'right_arrow'}
          color={cssVar(isOpen ? 'text-accent' : 'text-muted')}
          className="product-module-chevron"
        />
      </button>
      {isOpen && (
        <div className="product-module-details">
          {hasLinks && (
            <div className="product-module-links">
              {links.map((l) => (
                <Link key={l.link} className="product-module-link" to={`/${l.link}`}>
                  {l.label}
                  <Icon iconType="right_arrow" color={cssVar('text-muted')} size="small" />
                </Link>
              ))}
            </div>
          )}
          {!hasLinks && product.description && (
            <p className="product-module-description">{product.description}</p>
          )}
          <Link to={product.link} className="product-module-enter-link">
            <Button type="secondary" className="product-module-enter-button">
              Entrar no módulo
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
}
